import React from 'react';
import { Navbar } from '../components/Navbar';
import { BibleVerseHero } from '../components/BibleVerseHero';
import { ProductHero } from '../components/ProductHero';
import { ProductDetails } from '../components/ProductDetails';
import { TrustBar } from '../components/TrustBar';
import { BottleFeaturesSection } from '../components/BottleFeaturesSection';
import { OptimizedSaffronSection } from '../components/OptimizedSaffronSection';
import { GutBenefitsSection } from '../components/GutBenefitsSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { VideoTestimonialsSection } from '../components/VideoTestimonialsSection';
import { WhatToExpectSection } from '../components/WhatToExpectSection';
import { FAQSection } from '../components/FAQSection';
import { SuperfoodsPromoSection } from '../components/SuperfoodsPromoSection';
import { RelatedProductsSection } from '../components/RelatedProductsSection';
import { EnvironmentalImpactSection } from '../components/EnvironmentalImpactSection';
import { NewsletterSection } from '../components/NewsletterSection';
import { Footer } from '../components/Footer';
import { AnimatedWaveDivider } from '../components/AnimatedWaveDivider';
import { TestimonialsWaveDivider } from '../components/TestimonialsWaveDivider';
import { TestimonialsToWhatToExpectDivider } from '../components/TestimonialsToWhatToExpectDivider';
import { BottleToGutDivider } from '../components/BottleToGutDivider';
import { FAQToSuperfoodsDivider } from '../components/FAQToSuperfoodsDivider';
import { SuperfoodsToRelatedDivider } from '../components/SuperfoodsToRelatedDivider';
import { RelatedToEnvironmentalDivider } from '../components/RelatedToEnvironmentalDivider';
import { EnvironmentalToNewsletterDivider } from '../components/EnvironmentalToNewsletterDivider';
export function ProductPage() {
  return <div className="min-h-screen w-full bg-[#f5f1ed]" data-id="element-563">
      {/* Navbar */}
      <Navbar data-id="element-564" />

      {/* Bible Verse Hero - Right after navbar */}
      <div className="pt-16" data-id="element-565">
        <BibleVerseHero data-id="element-566" />
      </div>

      {/* Main Product Section - Unified Layout */}
      <main className="w-full" data-id="element-567">
        <div className="max-w-[1600px] mx-auto px-6 lg:px-12 py-8 lg:py-12" data-id="element-568">
          <div className="flex flex-col lg:flex-row gap-8 lg:gap-12" data-id="element-569">
            {/* Left Side - Product Images & Badges */}
            <div className="flex-1 lg:max-w-[55%]" data-id="element-570">
              <ProductHero data-id="element-571" />
            </div>

            {/* Right Side - Product Details */}
            <div className="flex-1 lg:max-w-[45%] flex items-start lg:items-center" data-id="element-572">
              <ProductDetails data-id="element-573" />
            </div>
          </div>
        </div>
      </main>

      {/* Trust Bar */}
      <TrustBar data-id="element-574" />

      {/* Beige to White - TrustBar to OptimizedSaffron */}
      <AnimatedWaveDivider topColor="#f5f1ed" bottomColor="#ffffff" data-id="element-575" />

      {/* Optimized Saffron Section */}
      <OptimizedSaffronSection data-id="element-576" />

      {/* What To Expect Timeline Section - Moved up */}
      <WhatToExpectSection data-id="element-577" />

      {/* Bottle Features Section */}
      <BottleFeaturesSection data-id="element-578" />

      {/* White to Beige - BottleFeatures to GutBenefits */}
      <BottleToGutDivider data-id="element-579" />

      {/* Gut Benefits Section */}
      <GutBenefitsSection data-id="element-580" />

      {/* Video Testimonials Section */}
      <VideoTestimonialsSection data-id="element-581" />

      {/* Beige to Dark Green - Video Testimonials to Testimonials */}
      <TestimonialsWaveDivider topColor="#f5f1ed" bottomColor="#2d4a3a" data-id="element-582" />

      {/* Testimonials Section */}
      <TestimonialsSection data-id="element-583" />

      {/* Dark Green to Beige - Testimonials to FAQ */}
      <TestimonialsToWhatToExpectDivider data-id="element-584" />

      {/* FAQ Section */}
      <FAQSection data-id="element-585" />

      {/* Beige to Dark Green - FAQ to Superfoods */}
      <FAQToSuperfoodsDivider data-id="element-586" />

      {/* Superfoods Promo Section */}
      <SuperfoodsPromoSection data-id="element-587" />

      {/* Dark Green to Beige - Superfoods to Related */}
      <SuperfoodsToRelatedDivider data-id="element-588" />

      {/* Related Products Section */}
      <RelatedProductsSection data-id="element-589" />

      {/* Beige to Black - Related to Environmental */}
      <RelatedToEnvironmentalDivider data-id="element-590" />

      {/* Environmental Impact Section */}
      <EnvironmentalImpactSection data-id="element-591" />

      {/* Black to Beige - Environmental to Newsletter */}
      <EnvironmentalToNewsletterDivider data-id="element-592" />

      {/* Newsletter Section */}
      <NewsletterSection data-id="element-593" />

      {/* Footer - No divider needed, Newsletter beige flows to Footer green */}
      <Footer data-id="element-594" />
    </div>;
}